function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';
const Facebook = props => {
  const theme = useTheme();
  const colors = theme.palette;
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    viewBox: "0 0 9 16",
    fill: "none",
    sx: {
      width: 9,
      height: 16
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00065 16.0004V8.00037H0.333984V5.3337H3.00065V3.9017C3.00065 1.19037 4.32132 0.000366211 6.57465 0.000366211C7.65398 0.000366211 8.22465 0.0803662 8.49465 0.117033V2.66703H6.95798C6.00132 2.66703 5.66732 3.1717 5.66732 4.19437V5.3337H8.47065L8.08998 8.00037H5.66732V16.0004H3.00065Z",
    fill: colors.common.white
  }));
};
export default Facebook;